import type { HandleChangeAnswerType } from '../model';
import type { AnswerUserType } from '~/model/AnswerUserType';
import { useTranslations } from 'next-intl';
import { useLayoutEffect } from 'react';
import { getIdFromUri } from '@/app/utils/entities/uri';
import { useFocus } from '~/hooks/useFocus';

export const TextTypeQuestion = ({
  answerUser,
  questionId,
  mandatory,
  handleChangeAnswer,
  type,
  disabled = false,
}: TextTypeQuestionPropsType) => {
  const t = useTranslations('FORM');
  const [inputRef, setInputFocus] = useFocus();
  const maxLength = 2000;

  useLayoutEffect(() => {
    setInputFocus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputRef.current]);

  return (
    <div className="vtmn-text-input_container">
      <textarea
        ref={inputRef}
        id={`question-${getIdFromUri(questionId)}`}
        data-testid="text"
        className="vtmn-text-input"
        value={
          answerUser[questionId] != null
            ? (answerUser[questionId].value as string)
            : ''
        }
        required={mandatory}
        aria-label={t('PLACEHOLDER_TEXT')}
        placeholder={t('PLACEHOLDER_TEXT')}
        onChange={(e) => {
          handleChangeAnswer(e.target.value, questionId, type, null);
        }}
        maxLength={maxLength}
        disabled={disabled}
      />
      <p className="text-input__counter vp-body-s">
        {`${
          (answerUser[questionId]?.value as string)?.length || 0
        }/${maxLength.toString()}`}
      </p>
    </div>
  );
};

interface TextTypeQuestionPropsType {
  answerUser: AnswerUserType;
  questionId: string;
  mandatory: boolean;
  handleChangeAnswer: HandleChangeAnswerType;
  type: string;
  disabled?: boolean;
}
